import React from 'react';
import { Box, keyframes } from '@mui/material';

const pulse = keyframes`
  0% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(26, 35, 126, 0.7);
  }
  
  70% {
    transform: scale(1);
    box-shadow: 0 0 0 20px rgba(26, 35, 126, 0);
  }
  
  100% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(26, 35, 126, 0);
  }
`;

const Loading = () => {
  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'rgba(255, 255, 255, 0.9)',
        backdropFilter: 'blur(8px)',
        zIndex: 9999,
      }}
    >
      <Box
        sx={{
          width: 80,
          height: 80,
          borderRadius: '50%',
          backgroundColor: '#1a237e',
          animation: `${pulse} 2s infinite`,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          position: 'relative',
          '&::before': {
            content: '""',
            position: 'absolute',
            width: '100%',
            height: '100%',
            borderRadius: '50%',
            border: '4px solid transparent',
            borderTopColor: '#fff',
            animation: 'spin 1s linear infinite',
          },
          '&::after': {
            content: '""',
            position: 'absolute',
            width: '70%',
            height: '70%',
            borderRadius: '50%',
            backgroundColor: '#fff',
            opacity: 0.2,
          },
        }}
      />
      <Box
        sx={{
          mt: 3,
          fontSize: '1.2rem',
          fontWeight: 500,
          color: '#1a237e',
          textAlign: 'center',
          animation: 'fadeInOut 1.5s infinite',
        }}
      >
        Loading...
      </Box>
    </Box>
  );
};

export default Loading; 